import { useTranslation } from "react-i18next";
import { LayoutGrid } from "lucide-react";
import { Button } from "components/common/Button";
import type { GridReviewButtonProps } from "./types";

export const GridReviewButton = ({
  onOpenGridReview,
}: GridReviewButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onOpenGridReview}
      startAdornment={<LayoutGrid size={14} />}
      className="shrink-0"
    >
      {t("smartSurveyor.gridReview.viewGrid")}
    </Button>
  );
};
